import React from 'react';

import { observer } from 'mobx-react';

import { useAction } from 'bz-utilities/hooks/action';
import useComputed from 'bz-utilities/hooks/computed';

import { View } from '@zinc/ui';
import { useMenuPageItem } from '../../stores/menu-store';
import { useMenuPage } from '../../stores/menu-store';
import Description from './controls/description';
import NestedPageOptions from './controls/options';
import NestedPageSublist from './controls/sub-list';
import NestedPageStore from './stores/nested-page-store';

export interface IProps {
  open?: boolean;
  route: string;
}

const NestedPage: React.FC<IProps> = observer(({ open, route }) => {
  const item = useMenuPageItem();
  const page = useMenuPage();

  const [store] = React.useState(() => new NestedPageStore(open));

  const isMenu: boolean = useComputed(() => {
    return !!store.isCreate || page.items.size > 0;
  }, [page]);

  const isOpen: boolean = useComputed(() => {
    return (!!store.isOpen && page.items.size > 0) || !!store.isCreate;
  }, [page]);

  const onToggle = useAction(() => {
    store.isOpen = !store.isOpen;
  }, [store]);

  const onSublist = useAction((): void => {
    store.isCreate = true;
    let el = document.getElementById(route);
    //threading hack to get focus to work
    setTimeout(() => {
      el?.focus();
    }, 0);
  }, [store]);

  const onAdd = useAction((): void => {
    store.isOpen = true;
    store.isCreate = false;
  }, [store]);

  const onBlur = useAction((): void => {
    store.isCreate = false;
  }, [store]);

  return (
    <div>
      <View direction="row">
        <View
          grow
          className="nowrap title-bar flex-row items-center border-[#808080] py-[5px] px-0"
        >
          <Description
            description={item.description}
            open={isOpen}
            isMenu={isMenu}
            onClick={onToggle}
          />
        </View>
        <NestedPageOptions onSublist={onSublist} />
      </View>
      {isOpen && <NestedPageSublist onAdd={onAdd} onBlur={onBlur} />}
    </div>
  );
});

NestedPage.displayName = 'NestedPage';

export default NestedPage;
